import { MRT_ColumnDef } from "material-react-table";
import { Job } from "../../../../api";
import { ColumnContext, dateColumn } from "./ColumnHelpers";

export function column_EstimatedFieldReadyDate(context: ColumnContext): MRT_ColumnDef<Job, unknown> {
	return dateColumn(context, "dateFieldReadyEstimated", "dateFieldReadyEstimated", {
		customRequiredMessage: "Estimated field ready date is required",
	});
}
